module.exports = __webpack_public_path__ + "img/App_Store_Badge_IT.fcf16c67.jpg";